import React from 'react';
import { cn } from '@/lib/utils';

export type DownloadButtonsProps = {
  appStoreUrl?: string;
  playStoreUrl?: string;
  layout?: 'row' | 'column';
  className?: string;
};

const DEFAULT_APP_STORE_URL = 'https://apps.apple.com/in/app/bevpass/id6477368545';
const DEFAULT_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.gk.bevpass&hl=en_US';

export function DownloadButtons({
  appStoreUrl = DEFAULT_APP_STORE_URL,
  playStoreUrl = DEFAULT_PLAY_STORE_URL,
  layout = 'row',
  className,
}: DownloadButtonsProps) {
  const containerClasses =
    layout === 'column'
      ? 'flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center'
      : 'flex flex-wrap items-center justify-center gap-3 sm:justify-start';

  return (
    <div className={cn(containerClasses, className)}>
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Download BevPass on the App Store"
        className="h-14 transition-transform duration-200 hover:scale-[1.02]"
      >
        <img
          src="/app-store-badge.svg"
          alt="Download on the App Store"
          className="h-full w-auto"
          loading="lazy"
        />
      </a>
      <a
        href={playStoreUrl}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Get BevPass on Google Play"
        className="h-14 transition-transform duration-200 hover:scale-[1.02]"
      >
        <img
          src="/google-play-badge.svg"
          alt="Get it on Google Play"
          className="h-full w-auto"
          loading="lazy"
        />
      </a>
    </div>
  );
}

export default DownloadButtons;
